<template>
  <el-dialog
    title="选择服务"
    :visible.sync="visible"
    width="640px"
    append-to-body=""
    @closed="handleClosed">
    <div class="search-form">
      <el-input
        v-model="config.name"
        placeholder="请输入姓名"
        style="width: 200px"
        class="input-with-select">
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="handleCurrentChange(1)"></el-button>
      </el-input>
    </div>
    <div v-loading="loading">
      <el-table
        border
        :data="list">
        <el-table-column
          label="微信用户ID"
          min-width="140"
          prop="wxappUserId"> </el-table-column>
        <el-table-column
          label="姓名"
          min-width="100"
          prop="name"> </el-table-column>
        <el-table-column
          label="微信手机号"
          width="110"
          prop="wxMobilePhone">
        </el-table-column>
        <el-table-column
          label="部门"
          min-width="160"
          prop="department"></el-table-column>
        <el-table-column
          label="选择"
          min-width="60"
          prop="vendorAddress">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="handleRowClick(row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        style="text-align: center;"
        :current-page="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
    <div slot="footer">
      <el-button @click="visible = false">取 消</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'VendorInviterSelectModal',
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      options: {},
      visible: false,
      config: { pageNum: 1, pageSize: 10, name: '' }
    }
  },
  methods: {
    handleClosed() {
      this.list = []
      this.total = 0
      this.config.pageNum = 1
      this.config.name = ''
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    handleRowClick(row) {
      const { wxappUserId, name } = row
      if (!wxappUserId) {
        this.$message.error('当前用户未在小程序注册，无法设置')
        return
      }
      this.$confirm(`您确定将${this.options.vendorName}的邀请人设置为${name}?`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$store.dispatch(`account/updatevendor`, {
            payload: { inviterWxappUserId: wxappUserId, vendorId: this.options.vendorId },
            success: () => {
              this.loading = false
              this.visible = false
              this.$message.success('更新成功')
              this.$emit('fetch')
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('account/getnamecards', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(options = {}) {
      this.options = options
      this.visible = true
      this.fetchList()
    }
  }
}
</script>
<style lang="stylus" scoped>
.search-form {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
